import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { DrawerProvider, useDrawer } from "./components/drawer/DrawerProvider";
import Drawer from "./components/drawer/Drawer";
import Router from "./routes/Router";
import { getCart } from "./store/features/cartSlice";
import Memberships from "./components/park/Memberships";
import Packages from "./components/park/Packages";
import AppConstants from "./constants/AppConstants";
import cookieService from "./services/cookieService";
import api from "./api/api";
import { setHandShakeStatus } from "./store/features/deviceSlice";

export default function App() {
  const dispatch = useDispatch();
  const { openDrawer } = useDrawer();
  const {
    drawerContent,
    drawerTitle,
    cartStatus,
    membershipStatus,
    packageStatus,
  } = useSelector((state) => state.deviceSlice);

  // App to web bridge communication
  // @TODO: remove console logs when js bridge communication is finalized
  useEffect(() => {
    const cookieConfig = {
      ...AppConstants.COOKIE_CONFIG,
      expires: 30,
    };

    const setCookiesFromData = ({ data }) => {
      if (!data || !data.token || !data.refresh_token || !data.user_data)
        return;
      console.debug(
        "[Super‑App] setting cookies from user data:",
        data,
        data.token,
        data.refresh_token,
        data.user_data
      );
      cookieService.set(
        AppConstants.CS_KEY.ACCESS_TOKEN,
        data.token,
        cookieConfig
      );
      cookieService.set(
        AppConstants.CS_KEY.REFRESH_TOKEN,
        data.refresh_token,
        cookieConfig
      );
      cookieService.set(
        AppConstants.CS_KEY.USER_PROFILE,
        JSON.stringify(data.user_data),
        cookieConfig
      );
    };

    const tick = () => {
      console.debug(
        "[Super‑App] checking for user data...",
        typeof window.onSuperAppUserDataReceived === "function"
      );
      if (typeof window.onSuperAppUserDataReceived === "function") {
        console.debug("[Super‑App] user data received from web bridge");
        const data = window.onSuperAppUserDataReceived();
        console.debug("[Super‑App] user data:", data);
        setCookiesFromData(data);
      }
    };

    tick();
  }, []);

  const fetchHandshake = useCallback(async () => {
    const res = await api.handshake();
    if (res?.status === 200) {
      const handshakeRes = res?.data?.data;
      sessionStorage.setItem(
        AppConstants.SS_KEY.HANDSHAKE_DATA,
        JSON.stringify(handshakeRes)
      );
      dispatch(setHandShakeStatus(true));
    }
  }, [dispatch]);

  useEffect(() => {
    fetchHandshake();
  }, [fetchHandshake]);

  useEffect(() => {
    dispatch(getCart());
  }, [dispatch]);

  useEffect(() => {
    if (membershipStatus) {
      openDrawer(<Memberships />, "Memberships");
    } else if (packageStatus) {
      openDrawer(<Packages />, "Packages");
    }
  }, [cartStatus, membershipStatus, packageStatus, openDrawer, drawerTitle]);

  return (
    <BrowserRouter basename="/park-tickets">
      <DrawerProvider>
        <Router />
        <Drawer title={drawerTitle}>{drawerContent || null}</Drawer>
      </DrawerProvider>
    </BrowserRouter>
  );
}
